//tslint:disable:max-file-line-count
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { isABDemandTrapExperiment } from '../../utils/ab_demand_trap_new_design';
import { AsideCountrysideBuilderPromoContainer } from '../AsideCountrysideBuilderPromo';
import { CountrysideBuilderProjectsBlockContainer } from '../CountrysideBuilderProjectsBlock';
import { HideOfferTopPopup } from '../popups/hide_offer_top_popup';
import { ProjectListBlockContainer } from '../ProjectListBlock';
import * as styles from './index.css';

import { AuthorContainer } from '../author/container';
import { AuthorBrandContainer } from '../author_brand/container';
import { ButtonCollapsed } from '@cian/components';
import { IDegradationInfoSchema, IOfferSchema, TOfferStatus } from '@cian/api-models/offer-card/v1/get-offer-data';
import { ErrorLogComponent } from '@cian/error-log-component';
import {
  BookingButtonInfoblockWidget,
  BookingPopupWidget,
  BookingStatus,
  IBookingTracking,
} from '@cian/pik-booking-widget';
import { numberToPrettyString, mergeStyles } from '@cian/utils';
import { IExperiment } from '../../api/experiments';
import { TrapContainer, ObservableTrapContainer } from '../demand/containers';
import { TrapNewContainer } from '../demand/containers/TrapNewContaner';
import { FeedbackComplaintPopupContainer } from '../../FeedbackExperiment/components/PopupWithComplaint/ComplaintPopup/container';
import { FeedbackPopupContainer as FeedBackPopupC } from '../../FeedbackExperiment/components/PopupWithComplaint/FeedbackPopup';
import { FeedbackFormPopupContainer } from '../../FeedbackExperiment/components/PopupWithForm/FeedbackFormPopup';
import { FeedbackPopupContainer as FeedbackPopupB } from '../../FeedbackExperiment/components/PopupWithForm/FeedbackPopup';
import { PopupFeedbackSentContainer } from '../../FeedbackExperiment/components/PopupWithForm/PopupFeedbackSent';
import { EGroup, getGroup } from '../../FeedbackExperiment/utils';
import { BannerContainer as StalkerBanner } from '../../registrationTriggers/StalkerBanner/components/Banner';
import { IContext } from '../../store';
import { getRandomId } from '../../utils/banners';
import { parseHash } from '../../utils/url_hash';
import { getBookingSuccessNotificationShownStatus, saveBookedOfferIdToLocalStorage } from '../../utils/booking';
import { checkFlocktoryLoad } from '../../utils/flocktory';
import { logComponentError } from '../../utils/log_component_error';
import { getOfferTitle, getSquareInformation, IParent } from '../../utils/offer_helpers';
import { TgbBannerContainer } from '../adfox/templates/tgb/banner';
import { AdminButtonsContainer } from '../admin_buttons/container';
import { OfferCardAsideContainer } from '../aside/container';
import { AsideBannersContainer } from '../aside_banners/container';
import { AuthorAsideContainer } from '../author_aside/container';
import { BottomControlPanelContainer } from '../bottom_control_panel/container';
import { BtiContainer } from '../bti_container';
import { BtiDistrictRatingContainer } from '../bti_district_rating/container';
import { BtiHouseDataContainer } from '../bti_house_data/container';
import { CommercialAboutBuildingContainer } from '../commercial/about_building/container';
import { CommercialAboutOtherContainer } from '../commercial/about_other/container';
import { ContactsMainContainer } from '../contacts_main/container';
import { BannerLegalSupportContainer } from '../banner_legal_support/container';
import { ContractRentSaleContainer } from '../contract_rent_sale/container';
import { DemolishedInMoscowProgrammContainer } from '../demolished_in_moscow_programm/container';
import { DescriptionContainer } from '../Description';
import { HeaderAdminPanelContainer } from '../header_admin_panel/container';
import { MainContainer } from '../main/container';
import { OfferMapContainer } from '../map/container';
import { OfferCardNavigationContainer } from '../navigation';
import { NewObjectStatsContainer } from '../newobject_stats/container';
import { OfferBreadcrumbsContainer } from '../offer_breadcrumbs/container';
import { OfferGallery } from '../offer_gallery';
import { OfferRefusedContainer } from '../offer_refused/container';
import { OfferUnpublishedContainer } from '../offer_unpublished/container';
import { PopupCallbackContainer } from '../popups/callback/container';
import { LegendModalContainer } from '../popups/legend/container';
import { PrintModalContainer } from '../popups/print/container';
import { RemoveModalContainer } from '../popups/remove/container';
import { PrintInformationContainer } from '../print_information/container';
import { PrintPhotoContainer } from '../print_photo/container';
import { ReviewFormContainer } from '../review/container';
import { SeoLinksContainer } from '../seo_links/container';
import { SimilarNewObjectsContainer } from '../similar_newobjects/container';
import { SimilarOffersGroupsContainer } from '../similar_offers/groups_container';
import { OfferTermsContainer } from '../terms/container';
import { WarningsContainer } from '../warnings/container';
import { OfferIsHiddenBlock } from '../offer_hidden_block';
import { EHideOfferState, ISetHideOfferInfo } from '../../store/hide_offer';
import { NewbuildingMVKContainer } from '../newbuilding_mvk/container';
import { AuthorAsideBrandContainer } from '../author_aside_brand/container';
import { OfferMeta } from '../offer_meta';
import { ModerationVerificationContainer } from '../moderation_verification/container';
import { SafeRentBlock } from '../SafeRentBlock';
import { NewSafeRentBlock } from '../NewSafeRentBlock';
import { SafeRentDescriptionContainer } from '../SafeRentDescription';
import { canShowTrap } from './helpers';
import { isNewbuilding, getOfferType, isUrban } from '../../utils/offer_type';
import { GeneralInformation } from './generalInformation';
import { CostEstimateContainer } from '../CostEstimate';
import { BtiErrorDataPopupContainer } from '../bti_error_data_popup/container';
import { VerifyPhoneContainer } from '../verifyPhone';
import { HomeownerBlockContainer } from '../HomeownerBlock';
import { HomeownerBlockAsideContainer } from '../HomeownerBlockAside/HomeownerBlockAside.container';
import { KpInfoContainer } from '../KpInfo';
import { SubscriptionAddressContainer } from '../subscription_address';
import { isAbExperiment } from '../../utils/isAbExperiment';
import { CARD_VISIBILITY_OBSERVATION } from '../../utils/cardVisibilityObservationExperiment';

import { NpsWidgetContainer } from './NpsWidgetContainer';
import { isLayoutSubscribeAddress } from '../subscription_address/experiments/layout_subscribe_address';
import { OfferCardServicePlaceUnderMapContainer } from '../offer-card-service-place-under-map/container';
import { CountrysidePromoBlockContainer } from '../CountrysidePromotionsBlock';
import { DealRent } from '../DealRent';
import { TourContainer } from '../TourContainer';

const PR1_RANDOM_TGB1 = getRandomId();
const PR1_RANDOM_TGB2 = getRandomId();
const PR1_RANDOM_TGB3 = getRandomId();
const NOT_SHOW_PIK_BOOKING_STATUS_POPUP = undefined;

export interface IOfferCardPageProps {
  context: IContext;
}

export interface IOfferCardPageStoreProps {
  offer: IOfferSchema;
  degradationInfo: IDegradationInfoSchema | null;
  status: TOfferStatus;
  parent: IParent | undefined;
  experiments?: IExperiment[];
  bookedOfferId: number;
  isPikBookingSucceeded: boolean;
  bookingTracking: IBookingTracking;
  isUserAuthenticated: boolean | null;
  isStalkerBannerShown: boolean;
  isBrandingAvailable: boolean;
  isPravocardEnabled: boolean;
  hideOfferStatus: EHideOfferState;
  hideOfferErrorMessage?: string;
  isTopPopupOpened: boolean;
  isHiddenByUser?: boolean | null;
  isNewBuilding: boolean;
  trackBookingPaymentSucceeded(): void;
  trackBookingPaymentFailed(): void;
  isCountrysideCardIntegrated: boolean;
  newbuildingDynamicCalltracking: number | null;
}

export interface IOfferCardPageDispatchProps {
  fetchAgent(): void;
  setKeyPushNotificationValue(value: boolean): void;
  saveToFavorite(): void;
  setHideOfferState(info: ISetHideOfferInfo): void;
  toggleTopPopup(isTopPopupOpened: boolean): void;
}

export interface IGetTopPopupParams {
  status: EHideOfferState;
  hidden: boolean;
  lkUrl: string;
  hideOfferErrorMessage?: string;
}

export type IProps = IOfferCardPageProps & IOfferCardPageStoreProps & IOfferCardPageDispatchProps;

export interface IOfferCardPageState {
  collapsed: boolean;
}
/* istanbul ignore next */
export class OfferCardPage extends React.Component<IProps, IOfferCardPageState> {
  private isBookingSuccessNotificationShown = false;

  public constructor(props: IProps) {
    super(props);

    this.state = {
      collapsed: props.offer.status !== 'published',
    };
  }

  public context: IContext;
  public isMount = false;

  public static childContextTypes = {
    config: PropTypes.object,
    httpApi: PropTypes.object,
    logger: PropTypes.object,
    makeRequest: PropTypes.func,
    pikBookingContext: PropTypes.object,
    telemetry: PropTypes.object,
  };

  public getChildContext() {
    return {
      config: this.props.context.config,
      httpApi: this.props.context.httpApi,
      logger: this.props.context.logger,
      makeRequest: this.props.context.makeRequest,
      pikBookingContext: this.props.context.pikBookingContext,
      telemetry: this.props.context.telemetry,
    };
  }

  public componentDidMount() {
    const {
      degradationInfo,
      bookedOfferId,
      setKeyPushNotificationValue,
      setHideOfferState,
      toggleTopPopup,
    } = this.props;
    this.isMount = true;
    if (degradationInfo && degradationInfo.agent) {
      this.props.fetchAgent();
    }

    this.isBookingSuccessNotificationShown = getBookingSuccessNotificationShownStatus(bookedOfferId);

    this.handleBooking();

    checkFlocktoryLoad()
      .then(flocktory => {
        flocktory
          .getSubscriptionStatus()
          .then(response => {
            /**
             * Если flocktory вернули поле subscribed и оно равно false,
             * значит текущий пользователь не подписан на пуши и нужно показать попап
             */
            if ('subscribed' in response && !response.subscribed) {
              setKeyPushNotificationValue(true);
            }
          })
          .catch(e => {
            throw e;
          });
      })
      .catch(e => {
        throw e;
      });

    const parsedHash = parseHash(window.location.hash);
    if (Object.keys(parsedHash).includes('HIDE')) {
      setHideOfferState({ status: parsedHash['HIDE'] as EHideOfferState });
      toggleTopPopup(true);
      history.pushState('', document.title, window.location.pathname + window.location.search);
    }
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    logComponentError({
      error,
      errorInfo,
      logger: this.props.context.logger,
    });
  }

  public render() {
    const {
      offer,
      context,
      experiments,
      bookedOfferId,
      isBrandingAvailable,
      isPravocardEnabled,
      isPikBookingSucceeded,
      isUserAuthenticated,
      isStalkerBannerShown,
      hideOfferStatus,
      isTopPopupOpened,
      isHiddenByUser = false,
      hideOfferErrorMessage,
      isNewBuilding,
      isCountrysideCardIntegrated,
    } = this.props;

    const isNewTrap = isABDemandTrapExperiment(experiments || []);

    const { isByHomeowner } = offer;

    const offerType = getOfferType(offer);

    const showTrap = !isNewTrap && canShowTrap(offer);
    const showNewTrap = isNewTrap && canShowTrap(offer);
    const shouldRenderBooking = Boolean(offer.booking);

    const shouldInformAboutStatusBooking = Boolean(
      Number(bookedOfferId) === offer.id && !this.isBookingSuccessNotificationShown,
    );

    const isSucceededBooking = shouldInformAboutStatusBooking
      ? isPikBookingSucceeded
      : NOT_SHOW_PIK_BOOKING_STATUS_POPUP;

    const feedbackGroup = experiments ? getGroup(experiments) : EGroup.aGroup;
    const hiddenObjectsLkUrl = context.config.get<string>('hiddenObjects.lkUrl') || '';
    //const newbuildingTourEnabled = context.config.get<boolean>('newbuildingTour.Enabled') || false;
    const newbuildingTourEnabled = true;

    const isSafeRentBlockShow = isByHomeowner && offer.flags && offer.flags.isDealRent;

    const TrapContainerComponent =
      experiments && isAbExperiment(experiments, CARD_VISIBILITY_OBSERVATION) ? ObservableTrapContainer : TrapContainer;

    const isNewSafeRentBlockShow = experiments && isAbExperiment(experiments, 'new_safe_rent_description');

    return (
      <>
        <main className={styles['offer_card_page']}>
          {feedbackGroup === EGroup.bGroup && <FeedbackPopupB />}
          {feedbackGroup === EGroup.bGroup && <FeedbackFormPopupContainer />}
          {feedbackGroup === EGroup.cGroup && <FeedBackPopupC />}
          {feedbackGroup === EGroup.cGroup && <FeedbackComplaintPopupContainer />}
          <PopupFeedbackSentContainer />

          <NewbuildingMVKContainer httpApi={context.httpApi} logger={context.logger} />
          {shouldRenderBooking && context.pikBookingContext && (
            <BookingPopupWidget isSucceededBooking={isSucceededBooking} widgetContext={context.pikBookingContext} />
          )}

          <div className={styles['offer_card_page-top']}>
            <OfferBreadcrumbsContainer />
            <OfferMeta isInHiddenBase={offer.isInHiddenBase} />
            <ModerationVerificationContainer />
            <HeaderAdminPanelContainer />
            <OfferRefusedContainer />
            <OfferUnpublishedContainer />
            <AdminButtonsContainer />
            <ErrorLogComponent logger={context.logger}>
              <WarningsContainer />
            </ErrorLogComponent>
          </div>
          <>
            {this.isMount && isTopPopupOpened && (
              <HideOfferTopPopup
                status={hideOfferStatus}
                hidden={Boolean(isHiddenByUser)}
                lkUrl={hiddenObjectsLkUrl}
                hideOfferErrorMessage={hideOfferErrorMessage}
              />
            )}
            {isHiddenByUser && <OfferIsHiddenBlock lkUrl={hiddenObjectsLkUrl} />}
          </>
          <div className={styles['offer_card_page-center']}>
            <div className={styles['offer_card_page-main']}>
              <ErrorLogComponent logger={context.logger}>
                <MainContainer />
              </ErrorLogComponent>
              {offer.status === 'published' && (
                <div>
                  <OfferGallery reactErrorLogger={context.logger} />
                  <PrintPhotoContainer />
                </div>
              )}
              {isSafeRentBlockShow && isNewSafeRentBlockShow && <SafeRentDescriptionContainer />}
              <DescriptionContainer />
              {newbuildingTourEnabled && <TourContainer />}
              {isCountrysideCardIntegrated && <KpInfoContainer />}
              <CommercialAboutBuildingContainer />
              <DemolishedInMoscowProgrammContainer />
              {offer.status !== 'published' && (
                <ButtonCollapsed
                  opened={!this.state.collapsed}
                  buttonText="Показать информацию"
                  closeButtonText="Скрыть информацию"
                  onClick={() => this.setState({ collapsed: !this.state.collapsed })}
                  buttonStyle={styles['button_collapsed']}
                />
              )}
              {offer.status === 'published' && <ContactsMainContainer />}
              {isPravocardEnabled && <BannerLegalSupportContainer />}
              {!isNewBuilding && (offer.status === 'published' || !this.state.collapsed) && (
                <GeneralInformation offer={offer} className={styles['section_divider']} />
              )}
            </div>
            <ProjectListBlockContainer />
            <CountrysideBuilderProjectsBlockContainer />
            {shouldRenderBooking && this.renderPIKBookingButtonInfoblock()}
            <CountrysidePromoBlockContainer />
            {(offer.status === 'published' || !this.state.collapsed) && [
              <div>
                <ErrorLogComponent logger={context.logger}>
                  <OfferMapContainer />
                </ErrorLogComponent>
                <OfferCardServicePlaceUnderMapContainer />
                <CommercialAboutOtherContainer />
                {isNewBuilding && (
                  <GeneralInformation
                    offer={offer}
                    {...mergeStyles(styles['offer_card_page-main'], styles['aside_banner'])}
                  />
                )}
                <NewObjectStatsContainer />
                <div className={styles['offer_card_page-bti']}>
                  <BtiContainer>
                    <BtiHouseDataContainer />
                    {isNewbuilding(offerType) && <BtiDistrictRatingContainer />}
                  </BtiContainer>
                  {isUrban(offerType) && !isLayoutSubscribeAddress(experiments) && <SubscriptionAddressContainer />}
                </div>
                <BtiErrorDataPopupContainer />
                <CostEstimateContainer />
                <BottomControlPanelContainer />
                <ErrorLogComponent logger={context.logger}>
                  <ContractRentSaleContainer />
                </ErrorLogComponent>
                <ErrorLogComponent logger={context.logger}>
                  {isByHomeowner && <HomeownerBlockContainer />}

                  {!isByHomeowner && (isBrandingAvailable ? <AuthorBrandContainer /> : <AuthorContainer />)}
                </ErrorLogComponent>
              </div>,
            ]}
          </div>
          <div className={styles['offer_card_page-aside']}>
            <OfferCardAsideContainer>
              <div className={styles['aside_content']}>
                <OfferTermsContainer />
                <DealRent />

                {isSafeRentBlockShow && (isNewSafeRentBlockShow ? <NewSafeRentBlock /> : <SafeRentBlock />)}

                {!isSafeRentBlockShow && isByHomeowner && <HomeownerBlockAsideContainer />}

                {!isSafeRentBlockShow &&
                  !isByHomeowner &&
                  (isBrandingAvailable ? <AuthorAsideBrandContainer /> : <AuthorAsideContainer />)}

                <ReviewFormContainer />
              </div>
              <AsideCountrysideBuilderPromoContainer />
              <ErrorLogComponent logger={context.logger}>
                <AsideBannersContainer />
              </ErrorLogComponent>
            </OfferCardAsideContainer>
          </div>
          <div className={styles['offer_card_page-footer']}>
            <SimilarOffersGroupsContainer />
            <SeoLinksContainer />
            <SimilarNewObjectsContainer />
            {showTrap && <TrapContainerComponent />}
            {showNewTrap && <TrapNewContainer />}
            <ErrorLogComponent logger={this.props.context.logger}>
              <VerifyPhoneContainer />
            </ErrorLogComponent>
            <div className={styles['bottom_banners']}>
              <ErrorLogComponent logger={context.logger}>
                <TgbBannerContainer
                  className={styles['bottom_banner']}
                  key="tgb1"
                  randomId={PR1_RANDOM_TGB1}
                  positionInfo="offer_card_tgb-1"
                />
              </ErrorLogComponent>
              <ErrorLogComponent logger={context.logger}>
                <TgbBannerContainer
                  className={styles['bottom_banner']}
                  key="tgb1"
                  randomId={PR1_RANDOM_TGB2}
                  positionInfo="offer_card_tgb-2"
                />
              </ErrorLogComponent>
              <ErrorLogComponent logger={context.logger}>
                <TgbBannerContainer
                  className={styles['bottom_banner']}
                  key="tgb3"
                  randomId={PR1_RANDOM_TGB3}
                  positionInfo="offer_card_tgb-3"
                />
              </ErrorLogComponent>
            </div>
          </div>

          <PopupCallbackContainer
            makeRequest={context.makeRequest}
            host={(context.config.get('apiBaseUrl') as string) || ''}
          />

          <PrintModalContainer />
          <PrintInformationContainer />

          <LegendModalContainer />
          <RemoveModalContainer />
          <OfferCardNavigationContainer />

          <NpsWidgetContainer />

          {!isUserAuthenticated && isStalkerBannerShown && (
            <ErrorLogComponent logger={context.logger}>
              <StalkerBanner />
            </ErrorLogComponent>
          )}
        </main>
      </>
    );
  }

  //TODO обернуть в отдельный компонент CD-37624

  private handleBooking() {
    const {
      offer,
      bookedOfferId,
      isPikBookingSucceeded,
      saveToFavorite,
      trackBookingPaymentFailed,
      trackBookingPaymentSucceeded,
    } = this.props;

    if (Number(bookedOfferId) === offer.id && !this.isBookingSuccessNotificationShown) {
      if (isPikBookingSucceeded) {
        saveBookedOfferIdToLocalStorage(bookedOfferId);
        saveToFavorite();
        trackBookingPaymentSucceeded();
      } else {
        trackBookingPaymentFailed();
      }
    }
  }

  private renderPIKBookingButtonInfoblock() {
    const { offer, context, parent, bookingTracking, bookedOfferId, isPikBookingSucceeded } = this.props;

    const { booking, bargainTerms, id } = offer;

    if (!booking || !context.pikBookingContext) {
      return null;
    }

    const offerDescription =
      `${getOfferTitle(offer)} · ${getSquareInformation(offer)} ` +
      `за ${numberToPrettyString(bargainTerms.prices.rur).replace(' ', '\u00a0')}\u00a0\u20bd` +
      `${parent ? ` в ЖК \u00AB${parent.name}\u00BB` : ''}`;

    const isBooked =
      Boolean(Number(bookedOfferId) === id && isPikBookingSucceeded) || booking.status === BookingStatus.inReserve;

    return (
      <div className={styles['container']}>
        <BookingButtonInfoblockWidget
          widgetContext={context.pikBookingContext}
          isBooked={isBooked}
          tracking={bookingTracking}
          bookingParams={{
            bookingPeriod: String(booking.bookingDuration),
            bookingPrice: String(booking.cost),
            cianOfferId: offer.cianId,
            offerDescription,
            pikOfferId: booking.externalId,
            similarOffersLink: booking.similarOffersUrl,
          }}
        />
      </div>
    );
  }
}
